/**
 * jbTable (JSON Bootstrap Table) (Version 0.1.6)
 *
 * Data grid styled using Bootstrap 3's table classes and scaffolding (http://twitter.github.io/bootstrap/base-css.html#tables)
 *
 * Notes:
 * See bstable.css for associated styles
 * IMPORTANT: This version has customized icons for sorting
 *
 * To-do:
 *
 * 0.1.0 - Initial Release
 * 2/23/2014 spm - Updated render to expect a flat JSON array like so (example only):
 *                 [{"key":"value","key1":"value1"},{"key2":"value2","key3":"value3"}] where the "key"
 *                 correlates to the jbtableColumn.slug field
 *
 * 3/1/2014 spm - Added BS2.3 support
 * 3/2/2014 spm - Added local data source support
 * 9/3/2014 spm - Added better support for hidden columns to enable searching for data that isn't visible
 * 9/3/2014 spm - Added local / limited sorting on non-dB columns
 * 10/5/2016 spm - Removed BS2 support
 * 10/5/2016 spm - Decoupled from $.widget
 *
 * @author      Steve Massey / Chris Schuld
 */

function jbtableColumn(options) {
    var defaults = {
        label: '',
        slug: '',
        searchable: false,
        sortable: false,
        sort: false,
        localSort: false, // dB sort support
        display: true,
        date: false,
        html: false,
        sortdir: 'desc',
        minwidth: 0,
        width: 0,
        maxwidth: 0,
        css: {},
        nowrap: false,
        render: function (data) { /* 'this' is the context of the HTML table cell for this column */
        }
    };
    options = $.extend(defaults, options);
    for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
            this[prop] = options[prop];
        }
    }
    return this;
}

function jbtableFilter(options) {
    var defaults = {
        label: '',
        value: '',
        active: false,
        displayLabel: true
    };
    options = $.extend(defaults, options);
    for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
            this[prop] = options[prop];
        }
    }
    return this;
}

function jbTable(element, options) {
    var defaults = {
        id: '',
        fixed: false, // fixed table layout
        columns: [], // collection of jbtableColumn objects
        filters: [], // collection of jbtableFilter objects
        perPage: 10,
        tableClasses: 'table table-striped table-bordered table-condensed',
        noResultsFound: '<div style="font-size:1.4em;">No results were found</div>',
        searchInput: '',
        filterActiveLabel: '<div class="label label-info">Your results are currently filtered by :filter</div>',
        extraLabel: '',
        /**
         * @param data object|function
         * By default this is a remote data source via HTTP GET (xhr)
         * Use a function instead of this object for local data handling
         * e.g.:
         * data: function () {
         *      var data = ["One", "Two", "Three"];
         *      // need to perform sort and search operations on data here
         *      this.totalResults = data.length;
         *      this.totalPages = Math.ceil(this.totalResults/this.options.perPage);
         *      this._generatePagerLinks();
         *      this._updatePager();
         *      // need to handle pagination of the data here
         *      return data;
         * }
         */
        data: { method: 'GET', url: '', local: null, params: null },
        onInit: function () {
        }, // called before render
        onAfterInit: function () {
        }, // called after render
        onBeforePageChange: function () {
        },
        onAfterPageChange: function () {
        },
        onSearch: function () {
        },
        onFilter: function () {
        },
        onPerPageChange: function () {
        },
        onPageChange: function () {
        },
        onSort: function () {
        }
    };

    if (!element) throw new Error("Please provide a valid selector, jquery, or DOM element as the first argument to this constructor");

    this.element = $(element);

    this.options = $.extend(true, defaults, options);
};

jbTable.prototype.page = 1;
jbTable.prototype.totalPages = 0;
jbTable.prototype.totalResults = 0;
jbTable.prototype.rendered = false;
jbTable.prototype._grid_data_request = null;

jbTable.prototype.init = function () {
    this.options.onInit.call(this);
    this._initDom();
    this._restoreState();
    this._getData();
    this.options.onAfterInit.call(this);
    if (this.options.fixed) {
        $(window).on('resize', $.proxy(function () {
            this._setFixedCellWidths();
        }, this));
    }
};

jbTable.prototype._trigger = function (name, data) {
    if (!this.options.hasOwnProperty(name)) {
        throw new Error("Invalid event name '" + name + "'");
    } else {
        this.options[name].call(this, data);
    }
};

jbTable.prototype._setOption = function (key, value) {
    this.options[key] = value;
};

jbTable.prototype._getId = function () {
    return this.element.prop('id');
};

jbTable.prototype._saveState = function () {
    var self = this;
    localStorage.setItem(this.options.id + '-last-search', this.options.searchInput);
    localStorage.setItem(this.options.id + '-last-perpage', this.options.perPage);
    localStorage.setItem(this.options.id + '-last-page', this.page);
    this.options.filters.forEach(function (filter) {
        if (filter.active) {
            if (filter.type) {
                localStorage.setItem(self.options.id + '-list-last-filter', filter.value);
            } else {
                localStorage.setItem(self.options.id + '-last-filter', filter.value);
            }
        }
    });
    this.options.columns.forEach(function (column) {
        if (column.sort) {
            localStorage.setItem(self.options.id + '-last-sort', column.slug);
            localStorage.setItem(self.options.id + '-last-sort-dir', column.sortdir);
        }
    });
};

jbTable.prototype._restoreState = function () {
    var self = this;
    var fetch = function (key) {
        var value = localStorage.getItem(key);
        return value;
    };
    var filterLocated = false, filterListLocated = false;
    // last search query
    var lastSearchQuery = fetch(this.options.id + '-last-search');
    if (lastSearchQuery && lastSearchQuery.length > 0) {
        this.options.searchInput = lastSearchQuery;
        this.element.find("[data-role='search']").find('input:first').val(lastSearchQuery);
        this._uiModifySearchButtonState(lastSearchQuery.length);
    }

    // last filter used
    var lastFilterUsed = fetch(this.options.id + '-last-filter');
    if (lastFilterUsed && lastFilterUsed.length > 0) {
        this.options.filters.forEach(function (filter) {
            if (filter.value == lastFilterUsed) {
                filter.active = true;
                filterLocated = true;
            } else {
                filter.active = false;
            }
        });
        if (!filterLocated && this.options.filters.length > 0) {
            this.options.filters[0].active = true;
            lastFilterUsed = this.options.filters[0].value;
        }
        this.element.find("[data-role='filter']").removeClass('active btn-primary');
        this.element.find("[data-role='filter'][data-value='" + lastFilterUsed + "']").addClass('active btn-primary')
    }
    var lastListFilterUsed = fetch(this.options.id + '-list-last-filter');
    if (lastListFilterUsed && lastListFilterUsed.length > 0) {
        this.options.filters.forEach(function (filter) {
            if (filter.type && 'list' == filter.type && Object.keys(filter.list).length) {
                if (lastListFilterUsed in filter.list) {
                    filter.value = lastListFilterUsed;
                    filter.active = true;
                    filterListLocated = true;
                    $('#list-filter').val(lastListFilterUsed);
                }
                if (filter.multiple) {
                    $('#list-filter').trigger('change.select2');
                }
            }
        });
        if (!filterListLocated && this.options.filters.length > 0) {
            $('#list-filter').val('');
        }
    }

    // last perpage used
    var lastPerPageUsed = fetch(this.options.id + '-last-perpage');
    if (lastPerPageUsed && lastPerPageUsed.length > 0) {
        this.options.perPage = lastPerPageUsed;
        this.element.find("[data-role='perpage']").find("option").prop('selected', false);
        this.element.find("[data-role='perpage']").find("option[value='" + lastPerPageUsed + "']").prop('selected', true);
    }

    // last page used
    var lastPageUsed = fetch(this.options.id + '-last-page');
    if (lastPageUsed && lastPageUsed.length > 0) {
        this.page = parseInt(lastPageUsed);
    }

    // last sorted column
    var lastSortedColumn = fetch(this.options.id + '-last-sort');
    if (lastSortedColumn && lastSortedColumn.length > 0) {
        this.options.columns.forEach(function (column) {
            column.sort = false;
            if (column.slug == lastSortedColumn) {
                column.sort = true;
            }
        });
    }

    // last sort direction
    var lastSortDirection = fetch(this.options.id + '-last-sort-dir');
    if (lastSortDirection && lastSortDirection.length > 0) {
        this.options.columns.forEach(function (column, index) {
            if (column.sort) {
                column.sortdir = lastSortDirection;
                self._uiModifySortColumnState(column.slug, column.sortdir);
            }
        });
    }
};

jbTable.prototype._resetFilters = function () {
    var self = this;
    localStorage.setItem(self.options.id + '-list-last-filter', null);
    localStorage.setItem(self.options.id + '-last-filter', '');

    self.options.filters.forEach(function (filter) {
        if (filter.label != 'All') {
            filter.active = false;
        }
    });
};

jbTable.prototype._uiModifySearchButtonState = function (boolState) {
    var that = this;
    if (boolState) {
        this.element.find("[data-role='searchbtn']").removeClass('btn-default').addClass('btn-primary').prop('title', 'A search is currently active');
        if (!this.element.find("[data-role='clearsearchbtn']").length) {
            this.element.find("[data-role='searchbtn']").after(
                $('<div style="display: inline-block; margin-left: 8px;">').append(
                    $('<button>', {'data-role': 'clearsearchbtn', type: 'button'}).addClass('btn btn-danger').text('Clear').click(function () {
                        that.element.find("[data-role='searchinput']").val('').trigger('keyup').focus();
                    }).css({
                        'width': '64px', 
                        'position': 'relative',
                         'top': '-2px',
                         'height': '36px'
                    })
                )
            );
        }
    } else {
        this.element.find("[data-role='searchbtn']").removeClass('btn-primary').addClass('btn-default').prop('title', '');
        this.element.find("[data-role='clearsearchbtn']").remove();
    }
}

jbTable.prototype._uiModifySortColumnState = function (slug, direction) {
    var col = this.element.find("[data-role='body'] table > thead > tr > th[data-slug='" + slug + "']");
    this.element.find("[data-role='body'] table > thead > tr > th i").removeClass('glyphicon-chevron-down glyphicon-chevron-up').addClass('bstable-icon-unsorted');
    this.element.find("[data-role='body'] table > thead > tr > th").not(col).each(function () {
        $(this).data('sort', '');
    });
    if (direction == 'desc') {
        col.data('sort', 'desc').find('i').removeClass('bstable-icon-unsorted').addClass('glyphicon glyphicon-chevron-down');
    } else {
        col.data('sort', 'asc').find('i').removeClass('bstable-icon-unsorted').addClass('glyphicon glyphicon-chevron-up');
    }
};

jbTable.prototype._initDom = function () {
    this._buildScaffolding();
    this._buildTable();
    this._buildPager();
    this.options.noResultsFound = $('<div>', {'data-role': 'noresults'}).css({
        'position': 'absolute',
        'top': '50%',
        'left': '50%'
    }).html(this.options.noResultsFound);
};

jbTable.prototype._buildScaffolding = function () {
    var that = this;
    var scaffolding = $('<div>').addClass('bstable table-responsive');
    scaffolding.append(
        $('<div>', {'data-role': 'head'}).addClass('row-fluid bstable-head'),
        $('<div>', {'data-role': 'body'}).addClass('row-fluid bstable-body'),
        $('<div>', {'data-role': 'foot'}).addClass('row-fluid bstable-foot')
    );
    this.element.append(scaffolding);
    var head = this.element.find("[data-role='head']");
    var searchInput = $('<div>', {'data-role': 'search'});
    if (this._isSearchable()) {
        searchInput.append(
            $('<div style="display: inline-block;">').append(
                $('<input>', {
                    'data-role': 'searchinput',
                    'type': 'text'
                }).addClass('form-control input-sm')
            ).css({'padding-right': '2px', 'padding-left': '0px'}),
            $('<div style="display: inline-block;">').append(
                $('<button>', {'data-role': 'searchbtn', type: 'button'}).addClass('btn btn-default btn-sm').text('Search')
            ).css('padding-left', '0px')
        );
        searchInput.attr('data-role', 'search');
        searchInput.find('input:first').on('keyup input paste', $.debounce(500, function () {
            $(this).data('lastsearch', $(this).val());
            that.options.searchInput = $(this).val();
            that.changePage(1);
            that._saveState();
            that._trigger('onSearch', that.options.searchInput);
            that._uiModifySearchButtonState($(this).val() != '');
        }));
    }
    var filters = $('<div>'), filters2 = '', listText = '', isMultiple = false, listwidth = '';
    if (this.options.filters.length > 0) {
        filters.addClass('btn-group');
        this.options.filters.forEach(function (filter) {
            if (filter.type && 'list' == filter.type && Object.keys(filter.list).length) {
                var select = $('<select class="form-control input-sm">').prop('id', 'list-filter');
                $.each(filter.list, function (key, value) {
                    var isSelected = false;
                    if (filter.active && key == filter.value) {
                        isSelected = true;
                    }
                    select
                        .append($('<option>', {value: key})
                            .text(value)
                            .prop('selected', isSelected)
                        );
                });
                listText = 'Filter by ' + filter.label + '  ';
                if (filter.multiple) {
                    isMultiple = true;
                    select.prop('multiple', true);
                    listwidth = filter.width ? filter.width : '225px';
                } else {
                    select.on('change', function () {
                        var value = $(this).val();
                        // set active filter
                        if ($(this).val() == 'fbd') {
                            filter.active = true;
                            filter.value = value;
                            $('#datepicker').css({
                                'display': 'inline-block',
                            }).focus().datepicker("show");
                        } else {
                            filter.active = true;

                            if ($(this).val() == '') {
                                filter.active = false;
                                localStorage.setItem('OrdersCompleteGrid-list-last-filter', '');
                            }

                            $("#datepicker").datepicker("hide").hide();

                            localStorage.setItem('OrdersCompleteGrid-date-filter', '');

                            filter.value = value;
                            that.changePage(1);
                            that._saveState();
                            that._trigger('onFilter', filter);
                        }
                    });
                }
                filters2 = $('<label>', {'data-role': 'filter', 'for': 'list-filter'}).append(select);
            } else {
                var filterBtn = $('<button>', {
                    'data-role': 'filter',
                    'data-value': filter.value,
                    type: 'button'
                }).addClass('btn btn-default btn-xs');
                if (filter.active) {
                    filterBtn.addClass('btn-primary active');
                }
                filterBtn.text(filter.label).click(function () {
                    // disable all filters
                    that.options.filters.forEach(function (_filter) {
                        if (!_filter.type)_filter.active = false;
                    });
                    $("[data-role='filter']").removeClass('btn-primary active');
                    // enable this filter
                    filter.active = true;
                    $(this).addClass('btn-primary active');
                    that.changePage(1);
                    that._saveState();
                    that._trigger('onFilter', filter);
                });
            }
            filters.append(filterBtn);
        });
    }
    head.append(
        $('<div>', {'data-role': 'filterlabel'}).addClass('bstable-filter-label'),
        $('<div>').addClass('bstable-header-container').append(
            $('<div>').addClass('bstable-header-filters').append(filters),
            $('<div>').addClass('bstable-header-search').append(searchInput),
            $('<div>').addClass('bstable-header-perpage').append(
                $('<label>', {'data-role': 'perpage', 'for': this._getId() + '-per-page'}).append(
                    $('<select class="form-control input-sm">').prop('id', this._getId() + '-per-page').append(
                        $('<option>').val(5).text(5),
                        $('<option>').val(10).text(10).prop("selected", true),
                        $('<option>').val(20).text(20),
                        $('<option>').val(30).text(30),
                        $('<option>').val(40).text(40),
                        $('<option>').val(50).text(50),
                        $('<option>').val(75).text(75),
                        $('<option>').val(100).text(100),
                        $('<option>').val(150).text(150),
                        $('<option>').val(200).text(200)
                    ).on('change', $.proxy(function () {
                        this.options.perPage = $('#' + this._getId() + '-per-page').val();
                        this.changePage(this.page);
                        this._saveState();
                        this._trigger('onPerPageChange', this.options.perPage);
                    }, this)),
                    ' per page'
                )
            ),
            $('<div>').addClass('bstable-header-list').css('position', 'relative').append(filters2)
        )
    );
    if (isMultiple) {
        $('#list-filter').select2({
            width: '225px',
            placeholder: listText,
            theme: "bootstrap"
        }).on("change", function (e) {
            var values = $('#list-filter').select2('val');

            that.options.filters.forEach(function (filter) {
                if (filter.type && 'list' == filter.type) {
                    filter.active = true;
                    filter.value = values == null ? '' : values;
                    that._trigger('onFilter', filter);
                }
            });

            that.changePage(1);
            that._saveState();
        });
        $('#list-filter').val(null).trigger('change.select2');
    }
};

jbTable.prototype._buildTable = function () {
    var body = this.element.find("[data-role='body']"),
        table = $('<table>').addClass(this.options.tableClasses),
        thead = $('<thead>'),
        tbody = $('<tbody>'),
        tfoot = $('<tfoot>'),
        that = this;

    thead.append($('<tr>'));

    $(this.options.columns).each(function (i, v) {
        if (!v.hasOwnProperty('display') || v.display) {
            var innerHeader = $('<div>').addClass(v.sortable ? 'bstable-header-inner' : 'bstable-header-inner-no-sort').html(v.label + ( v.sortable ? ' <i class="bstable-icon-unsorted"></i>' : ''));
            if (v.sortable) {
                innerHeader.click($.proxy(function () {
                    // update the UI to reflect which column is sorted on
                    var col = this.element.find("[data-role='body'] table > thead > tr > th[data-slug='" + v.slug + "']");


                    // clear out other sorts
                    this.options.columns.forEach(function (_col) {
                        _col.sort = false;
                    });

                    v.sort = true;

                    if (v.sortdir == '') {
                        v.sortdir = 'desc';
                    } else if (v.sortdir == 'desc') {
                        v.sortdir = 'asc';
                    } else {
                        v.sortdir = 'desc';
                    }

                    col.data('sort', v.sortdir);

                    this._uiModifySortColumnState(v.slug, v.sortdir);
                    this._saveState();
                    if (v.hasOwnProperty('localSort') && v.localSort) {
                        this.sortColumnClient(v.slug);
                    } else {
                        this.reload();
                    }
                    this._trigger('onSort', v);
                }, that));
            }
            var th = $('<th>', {
                'data-role': 'header',
                'data-slug': v.slug,
                'data-sort': ''
            }).addClass(v.sortable ? 'bstable-header bstable-header-sortable' : 'bstable-header').append(innerHeader);
            if (v.center) {
                th.addClass('bstable-center-align').css('text-align', 'center');
            }
            if (v.nowrap) {
                th.addClass('nowrap');
            }
            if (typeof v.width == 'string') {
                th.width(v.width + '%');
            } else if (v.width > 0) {
                th.width(v.width);
            }
            if (v.minwidth > 0) {
                th.css('min-width', v.minwidth + 'px');
            }
            if (v.maxwidth > 0) {
                th.css('max-width', v.maxwidth + 'px');
            }
            if (v.date) {
                th.data('date', true);
            }
            for (var cssKey in v.css) {
                if (v.css.hasOwnProperty(cssKey)) {
                    th.css(cssKey, v.css[cssKey]);
                }
            }
            thead.find('tr:first').append(th);
        }
    });

    if (this.options.fixed) {
        table.css({'table-layout': 'fixed'}).append(tbody, tfoot);
        var headerTable = $('<table class="fixed-jbtable-header-container" style="table-layout: fixed; margin-bottom: 0px !important;">').addClass(this.options.tableClasses).append(thead);
        var bodyTable = $('<div class="fixed-jbtable-body-container" style="overflow-y: auto; overflow-x: hidden;">').append(table);
        body.append(headerTable, bodyTable);
        this.element.find("[data-role='foot']").css({
            'margin-top': '10px'
        });
    } else {
        table.append(
            thead,
            tbody,
            tfoot
        ).appendTo(body);
    }

    // pre-sort:
    if (!this._isSorted()) {
        for (var column in this.options.columns) {
            if (this.options.columns[column].sort) {
                this.options.sortCol = column;
                this.options.sortDir = this.options.columns[column].sortdir;
                if (this.options.sortDir == '') {
                    this.options.sortDir = 'desc';
                }
                this._uiModifySortColumnState(this.options.columns[column].slug);
            }
        }
    }
};

jbTable.prototype._buildPager = function () {
    var that = this;
    var foot = this.element.find("[data-role='foot']");
    foot.append(
        $('<div>', {'data-role': 'pagexofy'}).addClass('bstable-pagexofy').html('Page ' + this.page + ' of ' + this.totalPages + ' &middot;'),
        $('<div>', {'data-role': 'totalresults'}).addClass('bstable-totalresults').text('Total: ' + this.totalResults)
    );
    var pager = $('<div>', {'data-role': 'pager'}).addClass('bstable-pager').appendTo(foot);
    var ul = $('<ul class="pagination">').appendTo(pager);
    ul.append($('<li>', {'data-role': 'pagelinkfirst'}).append(
        $('<a>').prop('href', 'javascript:;').text('First').click(function () {
            that.changePage(1);
        })
        )
    );
    ul.append(
        $('<li>', {'data-role': 'pageprev'}).append(
            $('<a>').prop('href', 'javascript:;').html('&laquo;')
                .click($.proxy(function () {
                    if (this.page - 1 >= 1) {
                        this.prevPage();
                    }
                }, this))
        )
    );
    ul.append(
        $('<li>', {'data-role': 'pagenext'}).append(
            $('<a>').prop('href', 'javascript:;').html('&raquo;')
                .click($.proxy(function () {
                    if (this.page + 1 <= this.totalPages) {
                        this.nextPage();
                    }
                }, this))
        )
    );
    ul.append($('<li>', {'data-role': 'pagelinklast'}).append(
        $('<a>').prop('href', 'javascript:;').text('Last').click(function () {
            that.changePage(that.totalPages);
        })
        )
    );
    var pages = $('<select>', {'data-role': 'pageselection'}).addClass('form-control pull-right').css({
        'height': '31px',
        'width': '75px'
    }).appendTo(pager);
    pages.change(function () {
        that.changePage(parseInt($(this).val()));
    });
    //this._generatePagerLinks();
};

jbTable.prototype._updatePager = function () {
    if (this.page <= 1) {
        this.element.find("[data-role='pager']").find("[data-role='pageprev']").addClass('disabled');
        this.element.find("[data-role='pager']").find("[data-role='pagelinkfirst']").addClass('disabled');
    } else {
        this.element.find("[data-role='pager']").find("[data-role='pageprev']").removeClass('disabled');
        this.element.find("[data-role='pager']").find("[data-role='pagelinkfirst']").removeClass('disabled');
    }
    if (this.page >= this.totalPages) {
        this.element.find("[data-role='pager']").find("[data-role='pagenext']").addClass('disabled');
        this.element.find("[data-role='pager']").find("[data-role='pagelinklast']").addClass('disabled');
    } else {
        this.element.find("[data-role='pager']").find("[data-role='pagenext']").removeClass('disabled');
        this.element.find("[data-role='pager']").find("[data-role='pagelinklast']").removeClass('disabled');
    }
    this.element.find("li[data-role='pagelink']").removeClass('active');
    this.element.find("li[data-role='pagelink'] > a[data-value='" + this.page + "']").parent().addClass('active');
    this.element.find("[data-role='pagexofy']").html('Page ' + this.page + ' of ' + this.totalPages + ' &middot;');
    this.element.find("[data-role='totalresults']").text('Total Results: ' + this.totalResults);
    if (this.totalPages > 25) {
        this.element.find("[data-role='pageselection']").show();
    } else {
        this.element.find("[data-role='pageselection']").hide();
    }
};

jbTable.prototype._generatePagerLinks = function () {
    var pager = this.element.find("[data-role='pager']");
    var ul = pager.find('ul');
    ul.find("[data-role='pagelink']").remove();
    var that = this;

    var margin = 3;

    if (this.totalPages < 7 + (margin * 2)) {
        for (var i = 1; i <= this.totalPages; i++) {
            ul.find("[data-role='pagenext']:first").before(
                $('<li>', {'data-role': 'pagelink'}).append(
                    $('<a>', {'data-value': i}).prop('href', 'javascript:;').text(i).click(function () {
                        that.changePage($(this).data('value'));
                    })
                )
            );
        }
    } else if (this.totalPages > 5 + (margin * 2)) {
        if (this.page < 1 + (margin * 2)) {
            for (var i = 1; i < 4 + (margin * 2); i++) {
                ul.find("[data-role='pagenext']:first").before(
                    $('<li>', {'data-role': 'pagelink'}).append(
                        $('<a>', {'data-value': i}).prop('href', 'javascript:;').text(i).click(function () {
                            that.changePage($(this).data('value'));
                        })
                    )
                );
            }
        } else if (this.totalPages - (margin * 2) > this.page && this.page > (margin * 2)) {
            for (var i = this.page - margin; i <= this.page + margin; i++) {
                ul.find("[data-role='pagenext']:first").before(
                    $('<li>', {'data-role': 'pagelink'}).append(
                        $('<a>', {'data-value': i}).prop('href', 'javascript:;').text(i).click(function () {
                            that.changePage($(this).data('value'));
                        })
                    )
                );
            }
        } else {
            for (var i = this.totalPages - (2 + (margin * 2)); i <= this.totalPages; i++) {
                ul.find("[data-role='pagenext']:first").before(
                    $('<li>', {'data-role': 'pagelink'}).append(
                        $('<a>', {'data-value': i}).prop('href', 'javascript:;').text(i).click(function () {
                            that.changePage($(this).data('value'));
                        })
                    )
                );
            }
        }
    }

    var pages = $("[data-role='pageselection']");
    pages.html('');

    if (that.totalPages > 1000) {
        for (var i = 1; i < that.totalPages; i++) {
            if (i <= 200 || i % 200 == 0) {
                pages.append('<option value="' + i + '">' + i + '</option>');
            }
        }
    } else if (that.totalPages > 100) {
        for (var i = 1; i < that.totalPages; i++) {
            if (i <= 100 || i % 50 == 0) {
                pages.append('<option value="' + i + '">' + i + '</option>');
            }
        }
    } else {
        for (var i = 1; i < that.totalPages; i++) {
            pages.append('<option value="' + i + '">' + i + '</option>');
        }
    }
    pages.find("option[value='" + that.page + "']").prop('selected', true);
};

jbTable.prototype._showLoading = function () {
    this.element.find("[data-role='body']").append(
        $('<img src="https://dlil96nns7nd5.cloudfront.net/images/wait-images/wait30trans.gif" data-role="loading-indicator"/>')
            .css({
                'position': 'absolute',
                'top': '50%',
                'left': '50%'
            })
    );
};

jbTable.prototype._hideLoading = function () {
    this.element.find("[data-role='loading-indicator']").fadeOut(function () {
        $(this).remove();
    });
};

jbTable.prototype._getData = function () {
    var self = this;
    self.rendered = false;
    this.element.find("[data-role='noresults']").remove();
    if (typeof this.options.data == 'object') {
        this._showLoading();
        if (this._grid_data_request) {
            this._grid_data_request.abort();
        }
        this._grid_data_request = $.ajax({
            type: this.options.data.method,
            url: this.options.data.url,
            timeout: 30000,
            cache: false,
            dataType: 'json',
            data: {
                page: this.page,
                perpage: this.options.perPage,
                search: this.options.searchInput,
                columns: function () {
                    return JSON.stringify(self.options.columns);
                },
                filters: function () {
                    return JSON.stringify(self.options.filters);
                },
                params: typeof this.options.data.params == 'function' ? this.options.data.params.call() : JSON.stringify(this.options.data.params)
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown);
        }).done($.proxy(function (json) {
            if (json.status == 'ok') {
                this.totalResults = json.total;
                this.totalPages = json.total > 0 ? Math.ceil(json.total / this.options.perPage) : 1;
                if (this.page > this.totalPages) {
                    this.changePage(1);
                } else {
                    this._render(json.data);
                    this._generatePagerLinks();
                    this._updatePager();
                }
                this._toggleSearchTr();
                this._toggleFilterTr();
                this._toggleExtraLabelTr();
            } else {
                console.error(json.message);
            }
        }, this)).always($.proxy(function () {
            this._hideLoading();
            this._grid_data_request = null;
        }, this));
    } else if (typeof this.options.data == 'function') {
        var data = this.options.data.call(self);
        this._render(data);
        this._toggleSearchTr();
        this._toggleFilterTr();
        this._toggleExtraLabelTr();
    }
};

jbTable.prototype._render = function (data) {
    var that = this;
    var tbody = this.element.find("[data-role='body']").find('tbody');
    tbody.find('tr').remove();
    if (this.totalResults == 0) {
        this.element.find("[data-role='body']").append(this.options.noResultsFound);
    } else {

        var hiddenColumns = {};
        for (var col in that.options.columns) {
            var column = that.options.columns[col];
            if (column.hasOwnProperty('display') && false == column.display) {
                hiddenColumns[col] = column;
            }
        }

        for (var i = 0, l = data.length; i < l; i++) {

            var tr = $('<tr id="' + this._getId() + '-row-' + i + '">')
                .appendTo(tbody);//.addClass(i % 2 ? 'odd' : 'even');

            if (this.options.fixed) {
                // hide the row so we avoid a weird pre-render post-render effect while we wait for the table to be fully displayed
                tr.hide();
            }

            // generate the <td>s
            for (var col in this.options.columns) {
                if (typeof this.options.columns[col] == 'object' && !hiddenColumns.hasOwnProperty(col)) {
                    var column = this.options.columns[col];
                    var td = $('<td data-slug="' + this.options.columns[col].slug + '" class="bstable-cell">')
                        .appendTo(tr);

                    if (column.html) {
                        td.data('html', true);
                    }
                    if (column.nowrap) {
                        td.addClass("nowrap");
                    }

                    // apply css rules
                    for (var cssKey in column.css) {
                        if (column.css.hasOwnProperty(cssKey)) {
                            td.css(cssKey, column.css[cssKey]);
                        }
                    }
                }
            }

            // insert data
            for (var dataKey in data[i]) {
                if (data[i].hasOwnProperty(dataKey)) {
                    if (dataKey != '') {
                        var dataValue = data[i][dataKey];
                        var td = tr.find('td[data-slug="' + dataKey + '"]');
                        if (td.data('html')) {
                            td.html(dataValue);
                        } else {
                            td.text(dataValue);
                        }
                    }
                }
            }

            // call render()
            var columnIndex = 0;
            for (var col in this.options.columns) {
                if (typeof this.options.columns[col] == 'object' && !hiddenColumns.hasOwnProperty(col)) {
                    var context = tr.find('td:eq(' + columnIndex + ')');
                    if (context.length) {
                        this.options.columns[col].render.call(context, data[i]);
                    }
                    columnIndex++;
                }
            }
        }
    }

    if (this.options.fixed) {
        this._setFixedCellWidths();
    }

    for (var col in this.options.columns) {
        if (this.options.columns[col].sort && this.options.columns[col].localSort) {
            this.sortColumnClient(this.options.columns[col].slug);
            break;
        }
    }

    this.rendered = true;
};

jbTable.prototype._toggleFilterTr = function () {
    this.element.find('.bstable-filter-tr').remove();
    var that = this;
    var filters = this._getActiveFilters();

    var label = '';
    if (filters.length) {
        if ($("#datepicker").size()) $('tr.bstable-filter-tr').remove();
        for (var i = 0, f = null; i < filters.length; ++i) {
            f = filters[i];
            if ('list' == f.type) {
                var lastFilter = localStorage.getItem(that.options.id + '-list-last-filter');
                if (lastFilter == 'fbd') {
                    var date = localStorage.getItem('OrdersCompleteGrid-date-filter');
                    label += label == '' ? date : ', ' + date;
                } else if (typeof f.list[lastFilter] != 'undefined')
                    label += label == '' ? f.label + ': ' + f.list[lastFilter] : ', ' + f.label + ': ' + f.list[lastFilter];
                else if (typeof f.list[f.value] != 'undefined')
                    label += label == '' ? f.label + ': ' + f.list[f.value] : ', ' + f.label + ': ' + f.list[f.value];
            } else {
                label += label == '' ? f.value : ', ' + f.value;
            }
        }
        if (label != '') {
            this.element.find('thead > tr:first').after(
                $('<tr class="bstable-filter-tr">').append(
                    $('<th colspan="' + that.options.columns.length + '">').append(
                        'results filtered by "' + label + '" - ',
                        $('<a href="javascript:;">').text('view all').click(function () {
                            $("[data-role='filter']").removeClass('btn-primary active');
                            that.element.find('.bstable-header-filters [data-role="filter"][data-value=""]').addClass('btn-primary active');
                            that.element.find('.bstable-header-list [data-role="filter"] select option[value="all"]').prop('selected', true);

                            if ($("#datepicker").size())
                                localStorage.setItem('OrdersCompleteGrid-date-filter', '');

                            $('#list-filter').val('');
                            that._resetFilters();
                            that.changePage(1);
                            that._saveState();
                            that._trigger('onFilter', f);
                        })
                    )
                )
            );
        }
    }
};

jbTable.prototype._toggleExtraLabelTr = function () {
    if (this.options.extraLabel != '') {
        this.element.find('.bstable-extra-label-tr').remove();
        var that = this,
            el;
        if (this.element.find('.bstable-filter-tr').length > 0) {
            el = this.element.find('.bstable-filter-tr');
        } else {
            el = this.element.find('thead > tr:first');
        }
        el.after(
            $('<tr class="bstable-extra-label-tr">').append(
                $('<th colspan="' + that.options.columns.length + '">').append(this.options.extraLabel)
            )
        );
    }
};

jbTable.prototype._toggleSearchTr = function () {
    this.element.find('.bstable-search-tr').remove();
    var that = this;
    var search = this.options.searchInput;
    if (search && search != '' && search.length > 0) {
        this.element.find('thead > tr:first').after(
            $('<tr class="bstable-search-tr">').append(
                $('<th colspan="' + that.options.columns.length + '">').append(
                    'results filtered by "' + search + '" - ',
                    $('<a href="javascript:;">').text('clear this search').click(function () {
                        that.element.find('[data-role=searchinput]').val('').trigger('keyup').focus();
                    })
                )
            )
        );
    }
};

jbTable.prototype._isSorted = function () {
    var self = this,
        sorted = false;

    this.options.columns.forEach(function (column) {
        if (column.sort) {
            sorted = true;
        }
    });

    return sorted == true;
};

jbTable.prototype._getSortCol = function () {
    var self = this,
        col = null;

    this.options.columns.forEach(function (column) {
        if (column.sort) {
            col = column;
        }
    });

    return col;
};

jbTable.prototype._getSortDir = function () {
    var self = this,
        dir = '';

    this.options.columns.forEach(function (column) {
        if (column.sort) {
            dir = column.sortdir;
        }
    });

    return dir;
};

jbTable.prototype._getSearchableColumns = function () {
    var columns = [];
    for (var i = 0; i < this.options.columns.length; i++) {
        if (this.options.columns[i].searchable) {
            columns.push(this.options.columns[i]);
        }
    }
    return columns;
};

jbTable.prototype._getSearchableColumnFieldNames = function () {
    var fields = [];
    var columns = this._getSearchableColumns();
    for (var i = 0; i < columns.length; i++) {
        fields.push(columns[i].slug);
    }
    return fields;
};

jbTable.prototype._isSearchable = function () {
    var columns = this._getSearchableColumns();
    return columns.length > 0;
};

jbTable.prototype._getColumnSlug = function (index) {
    var slug = '';
    for (var i = 0, header = null; header == null && i < this.options.columns.length; i++) {
        if (i == index) {
            var column = this.options.columns[i];
            slug = column.slug;
        }
    }
    return slug;
};

jbTable.prototype._getFilterValues = function () {
    var values = [];
    this.options.filters.forEach(function (item) {
        values.push(item.value);
    });
    return values;
};

jbTable.prototype._getActiveFilter = function () {
    var retval = null;
    this.options.filters.forEach(function (item) {
        if (item.active) {
            retval = item;
        }
    });
    return retval;
};

jbTable.prototype._getActiveFilters = function () {
    var retval = [];
    this.options.filters.forEach(function (item) {
        if (item.active) {
            retval.push(item);
        }
    });
    return retval;
};

jbTable.prototype._setFixedCellWidths = function () {
    var that = this;
    // set a timeout to give the browser a little extra time to fully render the table before we set widths
    setTimeout(function () {
        // column widths must match
        that.element.find('.fixed-jbtable-header-container').find('tr:first > th').each(function () {
            var th = $(this);
            that.element.find('.fixed-jbtable-body-container').find('tr').each(function () {
                $(this).find('td:eq(' + th.index() + ')').width(th.width());
                $(this).show();
            });
        });
    }, 50);
};

jbTable.prototype.destroy = function () {
    this.element.empty();
};

jbTable.prototype.reload = function () {
    this.changePage(this.page);
};

jbTable.prototype.changePage = function (pageIndex) {
    this._trigger('onBeforePageChange', this.page);
    this._trigger('onPageChange', this.page);
    this.page = pageIndex;
    this._getData();
    this._trigger('onAfterPageChange', this.page);
    this._saveState();
};

jbTable.prototype.nextPage = function () {
    this.changePage(this.page + 1);
};

jbTable.prototype.nextPage = function () {
    this.changePage(this.page + 1);
};

jbTable.prototype.prevPage = function () {
    this.changePage(this.page - 1);
};

jbTable.prototype.setFixedBodyHeight = function (height) {
    if (this.options.fixed) {
        this.element.find('.fixed-jbtable-body-container').height(height);
    }
};

jbTable.prototype.isRendered = function () {
    return this.rendered == true;
};

jbTable.prototype.sortColumnClient = function (slug) {
    var col = this.element.find("[data-role='body'] table > thead > tr > th[data-slug='" + slug + "']");
    var index = col.index();
    var tbody = this.element.find("[data-role='body'] table > tbody");
    var rows = tbody.find('tr');
    var data = [];
    rows.each(function (a, v) {
        data.push({id: $(this).prop('id'), value: $(this).find('td:eq(' + index + ')').text(), date: col.data('date')});
    });
    if (col.data('sort') == 'asc' || col.data('sort') == '') {
        // currently ascending order, swap to descending
        data.sort(function (a, b) {
            if (a.date && b.date) {
                a = Date.create(a.value);
                b = Date.create(b.value);
                return a > b ? -1 : 1;
            } else {
                var avalue = !isNaN(a.value) ? parseFloat(a.value) : a.value;
                var bvalue = !isNaN(b.value) ? parseFloat(b.value) : b.value;
                if (avalue < bvalue) {
                    return -1;
                } else if (avalue > bvalue) {
                    return 1;
                }
            }
            return 0;
        });
        for (var i = data.length; --i >= 0;) {
            var row = tbody.find('#' + data[i].id);
            tbody.prepend(row);
            row.removeClass('even odd')
            if (i % 2 == 1) {
                row.addClass('even');
            } else {
                row.addClass('odd');
            }
        }
    } else {
        // currently descending order, swap to ascending
        data.sort(function (a, b) {
            if (a.date && b.date) {
                a = Date.create(a.value);
                b = Date.create(b.value);
                return a > b ? 1 : -1;
            } else {
                var avalue = !isNaN(a.value) ? parseFloat(a.value) : a.value;
                var bvalue = !isNaN(b.value) ? parseFloat(b.value) : b.value;
                if (avalue < bvalue) {
                    return 1;
                } else if (avalue > bvalue) {
                    return -1;
                }
            }
            return 0;
        });
        for (var i = data.length; --i >= 0;) {
            var row = tbody.find('#' + data[i].id);
            tbody.prepend(row);
            row.removeClass('even odd')
            if (i % 2 == 1) {
                row.addClass('even');
            } else {
                row.addClass('odd');
            }
        }
    }
};
